import { Select } from "antd";
import PagamentoTipo from "../../../../../../Models/Financeiro/Titulo/Pagamento/PagamentoTipo";
import { usePagamentoTipoListar } from "../../../../../../Services/Financeiro/Titulo/Pagamento/PagamentoTipoServices";
import { SelectComPesquisa } from "../../../../../SelectComPesquisa";
interface IPagamentoTipoSelectProps extends Omit<React.ComponentProps<typeof Select>, "value" | "onChange" | "showSearch" | "optionFilterProp" | "filterOption"> {
    ativoParam?:boolean;
    pagamentoTipoParam?:PagamentoTipo;
    tipoInvalidos?:number[];
    value?:number|PagamentoTipo
    onChange?:(tipo:PagamentoTipo|null) => void
}
export default function PagamentoTipoSelect({
    ativoParam,
    pagamentoTipoParam,
    placeholder,
    allowClear,
    loading,
    disabled,
    tipoInvalidos,
    value,
    onChange,
    ...rest
}:IPagamentoTipoSelectProps) {
    const {
        data,
        isLoading,
        isError
    } = usePagamentoTipoListar({
        ativo : ativoParam,
        pagamentoTipo : pagamentoTipoParam
    });

    return <SelectComPesquisa
        {...rest}
        placeholder={placeholder ?? "Selecione"}
        allowClear={allowClear ?? true}
        loading={loading ?? isLoading}
        disabled={disabled ?? isError}
        value={typeof value === "number" ? value : value?.codigo}
        onChange={(value) => {
            onChange?.(data?.find(f => f.codigo === value) ?? null);
        }}
        options={data?.filter(f => tipoInvalidos === undefined || !tipoInvalidos.includes(f.codigo))?.map(m => {
            return {
                value : m.codigo,
                label : m.nome
            }
        })}
    /> 
}